
import React from 'react';
import { useAuthForm } from '@/hooks/useAuthForm';
import FormFields from './AuthFormFields';
import FormFooter from './AuthFormFooter';
import AuthAlerts from './AuthAlerts';

interface AuthFormProps {
  onResetClick: () => void;
  onSuccess?: () => void;
  redirectUrl?: string;
}

const AuthForm = ({ onResetClick, onSuccess, redirectUrl }: AuthFormProps) => {
  const {
    isLogin,
    email,
    setEmail,
    password,
    setPassword,
    fullName,
    setFullName,
    showPassword,
    setShowPassword,
    loading,
    showConfirmMessage,
    errorMessage,
    handleSubmit,
    toggleForm
  } = useAuthForm(onResetClick, onSuccess, redirectUrl);

  return (
    <div className="space-y-4">
      <AuthAlerts 
        showConfirmMessage={showConfirmMessage}
        errorMessage={errorMessage}
      />
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <FormFields 
          isLogin={isLogin}
          email={email}
          setEmail={setEmail}
          password={password}
          setPassword={setPassword}
          fullName={fullName}
          setFullName={setFullName}
          showPassword={showPassword}
          setShowPassword={setShowPassword}
        />
        
        <FormFooter 
          isLogin={isLogin}
          loading={loading}
          onToggle={toggleForm}
          onResetClick={onResetClick}
        />
      </form>
    </div>
  );
};

export default AuthForm;
